import DeleteIcon from '@mui/icons-material/Delete';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Avatar, Box, IconButton } from '@mui/material';
import { useTranslationContext } from '../../../../context/TranslationContext';

type AvatarWithActionsProps = {
  src?: string;
  alt: string;
  onError?: () => void;
  onUpload?: () => void;
  onDelete?: () => void;
  isUploading?: boolean;
  isDeleting?: boolean;
};

const AvatarWithActions = ({
  src,
  alt,
  onError,
  onUpload,
  onDelete,
  isUploading,
  isDeleting,
}: AvatarWithActionsProps) => {
  const t = useTranslationContext();
  return (
    <Box
      sx={{
        width: 60,
        height: 60,
        mb: 1,
        position: 'relative',
        '&:hover .avatar-actions, &:focus-within .avatar-actions': {
          opacity: 1,
          pointerEvents: 'auto',
        },
      }}
    >
      <Avatar
        src={src}
        alt={alt}
        onError={onError}
        sx={{
          width: 60,
          height: 60,
        }}
      />

      <Box
        className="avatar-actions"
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          bgcolor: 'rgba(0, 0, 0, 0.35)',
          opacity: 0,
          pointerEvents: 'none',
          transition: 'opacity 0.2s ease-in-out',
        }}
      >
        <IconButton
          size="small"
          aria-label={t('avatar.upload')}
          onClick={onUpload}
          disabled={Boolean(isUploading)}
          sx={{
            color: 'common.white',
            bgcolor: 'rgba(0, 0, 0, 0.25)',
            '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.35)' },
          }}
        >
          <PhotoCameraIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="small"
          aria-label={t('avatar.delete')}
          onClick={onDelete}
          disabled={Boolean(isDeleting)}
          sx={{
            color: 'common.white',
            bgcolor: 'rgba(0, 0, 0, 0.25)',
            '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.35)' },
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default AvatarWithActions;
